module.exports = __webpack_public_path__ + "img/open.e4568d3e.svg";